"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonStyles = void 0;

var _styledComponents = require("styled-components");

var _getColor = require("../styleHelpers/getColor");

var _getSpacing = require("../styleHelpers/getSpacing");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var buttonStyles = {
  base: {
    borderRadius: (0, _getSpacing.getSpacing)(2),
    icon: {
      gap: (0, _getSpacing.getSpacing)(4),
      size: {
        small: '20px',
        medium: '20px',
        large: '20px'
      }
    },
    disabled: {
      opacity: 0.4
    },
    borderSize: 1,
    focus: {
      outlineSize: (0, _getSpacing.getSpacing)(2)
    },
    active: {
      outlineSize: (0, _getSpacing.getSpacing)(0.5),
      transform: 'scale(0.985)'
    },
    transitions: [['background-color, 0.3s'], ['color', '0.3s'], ['border-color', '0.3s'], ['box-shadow', '0.3s', 'ease-in-out'], ['transform, 0.15s']]
  },
  sizes: {
    small: {
      padding: (0, _styledComponents.css)(["5px 8px"])
    },
    medium: {
      padding: (0, _styledComponents.css)(["10px 14px"])
    },
    large: {
      padding: (0, _styledComponents.css)(["14px 22px"])
    }
  },
  plain: {
    outlineColor: (0, _getColor.getColor)('gray', '50'),
    primary: {
      color: (0, _getColor.getColor)('common', 'black'),
      backgroundColor: (0, _getColor.getColor)('gray', '50'),
      borderColor: (0, _getColor.getColor)('gray', '100'),
      hover: {
        color: (0, _getColor.getColor)('common', 'black'),
        backgroundColor: (0, _getColor.getColor)('gray', '100'),
        borderColor: (0, _getColor.getColor)('gray', '200')
      },
      active: {
        color: (0, _getColor.getColor)('common', 'black'),
        backgroundColor: (0, _getColor.getColor)('gray', '200'),
        borderColor: (0, _getColor.getColor)('gray', '300')
      }
    },
    primaryInverted: {
      color: (0, _getColor.getColor)('common', 'black'),
      backgroundColor: (0, _getColor.getColor)('common', 'white'),
      borderColor: (0, _getColor.getColor)('common', 'white'),
      hover: {
        color: (0, _getColor.getColor)('common', 'black'),
        backgroundColor: (0, _getColor.getColor)('gray', '50'),
        borderColor: (0, _getColor.getColor)('gray', '50')
      },
      active: {
        color: (0, _getColor.getColor)('common', 'black'),
        backgroundColor: (0, _getColor.getColor)('gray', '100'),
        borderColor: (0, _getColor.getColor)('gray', '100')
      }
    },
    secondary: {
      color: (0, _getColor.getColor)('common', 'black'),
      backgroundColor: 'transparent',
      borderColor: (0, _getColor.getColor)('common', 'black'),
      hover: {
        color: (0, _getColor.getColor)('common', 'black'),
        backgroundColor: (0, _getColor.getColor)('gray', '50'),
        borderColor: (0, _getColor.getColor)('common', 'black')
      },
      active: {
        color: (0, _getColor.getColor)('common', 'black'),
        backgroundColor: (0, _getColor.getColor)('gray', '100'),
        borderColor: (0, _getColor.getColor)('common', 'black')
      }
    },
    secondaryInverted: {
      color: (0, _getColor.getColor)('common', 'white'),
      backgroundColor: 'transparent',
      borderColor: (0, _getColor.getColor)('common', 'white'),
      hover: {
        color: (0, _getColor.getColor)('common', 'white'),
        backgroundColor: (0, _getColor.getColor)('gray', '800'),
        borderColor: (0, _getColor.getColor)('common', 'white')
      },
      active: {
        color: (0, _getColor.getColor)('common', 'white'),
        backgroundColor: (0, _getColor.getColor)('gray', '600'),
        borderColor: (0, _getColor.getColor)('common', 'white')
      }
    },
    text: {
      color: (0, _getColor.getColor)('common', 'black'),
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      hover: {
        color: (0, _getColor.getColor)('common', 'black'),
        backgroundColor: (0, _getColor.getColor)('gray', '50'),
        borderColor: 'transparent'
      },
      active: {
        color: (0, _getColor.getColor)('common', 'black'),
        backgroundColor: (0, _getColor.getColor)('gray', '100'),
        borderColor: 'transparent'
      }
    },
    textInverted: {
      color: (0, _getColor.getColor)('common', 'white'),
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      hover: {
        color: (0, _getColor.getColor)('common', 'white'),
        backgroundColor: (0, _getColor.getColor)('gray', '800'),
        borderColor: 'transparent'
      },
      active: {
        color: (0, _getColor.getColor)('common', 'white'),
        backgroundColor: (0, _getColor.getColor)('gray', '600'),
        borderColor: 'transparent'
      }
    }
  },
  brand: {
    outlineColor: (0, _getColor.getColor)('brand', 'lightest'),
    primary: createShadedButtonPrimaryStyles('brand'),
    primaryInverted: createShadedButtonPrimaryInvertedStyles('brand'),
    secondary: createShadedButtonSecondaryStyles('brand'),
    secondaryInverted: createShadedButtonSecondaryInvertedStyles('brand'),
    text: createShadedButtonTextStyles('brand'),
    textInverted: createShadedButtonTextInvertedStyles('brand')
  },
  positive: {
    outlineColor: (0, _getColor.getColor)('positive', 'lightest'),
    primary: createShadedButtonPrimaryStyles('positive'),
    primaryInverted: createShadedButtonPrimaryInvertedStyles('positive'),
    secondary: createShadedButtonSecondaryStyles('positive'),
    secondaryInverted: createShadedButtonSecondaryInvertedStyles('positive'),
    text: createShadedButtonTextStyles('positive'),
    textInverted: createShadedButtonTextInvertedStyles('positive')
  },
  negative: {
    outlineColor: (0, _getColor.getColor)('negative', 'lightest'),
    primary: createShadedButtonPrimaryStyles('negative'),
    primaryInverted: createShadedButtonPrimaryInvertedStyles('negative'),
    secondary: createShadedButtonSecondaryStyles('negative'),
    secondaryInverted: createShadedButtonSecondaryInvertedStyles('negative'),
    text: createShadedButtonTextStyles('negative'),
    textInverted: createShadedButtonTextInvertedStyles('negative')
  }
};
exports.buttonStyles = buttonStyles;

function createShadedButtonPrimaryStyles(color) {
  return {
    color: (0, _getColor.getColor)(color, 'contrastText'),
    backgroundColor: (0, _getColor.getColor)(color),
    borderColor: (0, _getColor.getColor)(color),
    hover: {
      color: (0, _getColor.getColor)(color, 'contrastText'),
      backgroundColor: (0, _getColor.getColor)(color, 'dark'),
      borderColor: (0, _getColor.getColor)(color, 'dark')
    },
    active: {
      color: (0, _getColor.getColor)(color, 'contrastText'),
      backgroundColor: (0, _getColor.getColor)(color, 'darkest'),
      borderColor: (0, _getColor.getColor)(color, 'darkest')
    }
  };
}

function createShadedButtonPrimaryInvertedStyles(color) {
  return {
    color: (0, _getColor.getColor)(color),
    backgroundColor: (0, _getColor.getColor)(color, 'contrastText'),
    borderColor: (0, _getColor.getColor)(color, 'contrastText'),
    hover: {
      color: (0, _getColor.getColor)(color),
      backgroundColor: (0, _getColor.getColor)(color, 'lightest'),
      borderColor: (0, _getColor.getColor)(color, 'lightest')
    },
    active: {
      color: (0, _getColor.getColor)(color),
      backgroundColor: (0, _getColor.getColor)(color, 'light'),
      borderColor: (0, _getColor.getColor)(color, 'light')
    }
  };
}

function createShadedButtonSecondaryStyles(color) {
  var textStyles = createShadedButtonTextStyles(color);
  return _objectSpread(_objectSpread({}, textStyles), {}, {
    hover: _objectSpread(_objectSpread({}, textStyles.hover), {}, {
      borderColor: (0, _getColor.getColor)(color, 'darkest')
    }),
    active: _objectSpread(_objectSpread({}, textStyles.active), {}, {
      borderColor: (0, _getColor.getColor)(color, 'darkest')
    }),
    borderColor: (0, _getColor.getColor)(color, 'dark')
  });
}

function createShadedButtonSecondaryInvertedStyles(color) {
  var textStyles = createShadedButtonTextInvertedStyles(color);
  return _objectSpread(_objectSpread({}, textStyles), {}, {
    hover: _objectSpread(_objectSpread({}, textStyles.hover), {}, {
      borderColor: (0, _getColor.getColor)(color, 'contrastText')
    }),
    active: _objectSpread(_objectSpread({}, textStyles.active), {}, {
      borderColor: (0, _getColor.getColor)(color, 'contrastText')
    }),
    borderColor: (0, _getColor.getColor)(color, 'contrastText')
  });
}

function createShadedButtonTextStyles(color) {
  return {
    color: (0, _getColor.getColor)(color, 'dark'),
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    hover: {
      color: (0, _getColor.getColor)(color, 'darkest'),
      backgroundColor: (0, _getColor.getColor)(color, 'lightest'),
      borderColor: 'transparent'
    },
    active: {
      color: (0, _getColor.getColor)(color, 'darkest'),
      backgroundColor: (0, _getColor.getColor)(color, 'light'),
      borderColor: 'transparent'
    }
  };
}

function createShadedButtonTextInvertedStyles(color) {
  return {
    color: (0, _getColor.getColor)(color, 'contrastText'),
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    hover: {
      color: (0, _getColor.getColor)(color, 'contrastText'),
      backgroundColor: (0, _getColor.getColor)(color, 'dark'),
      borderColor: 'transparent'
    },
    active: {
      color: (0, _getColor.getColor)(color, 'contrastText'),
      backgroundColor: (0, _getColor.getColor)(color, 'darkest'),
      borderColor: 'transparent'
    }
  };
}